var isArray = require('../is/array')
var isNull = require('../is/null')

/* prettier-ignore */
/**
 * @desc when Array -> 'array'
 *       when null -> 'null'
 *       else `typeof x`
 * @param  {any} x
 * @return {string} type
 */
module.exports = function (x) {
  return isArray(x)
    ? 'array'
    : isNull(x)
      ? 'null'
      : typeof x
}

//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic2ltcGxlS2luZE9mLmpzIiwic291cmNlcyI6WyJzaW1wbGVLaW5kT2YuanMiXSwic291cmNlc0NvbnRlbnQiOlsiY29uc3QgaXNBcnJheSA9IHJlcXVpcmUoJy4uL2lzL2FycmF5JylcbmNvbnN0IGlzTnVsbCA9IHJlcXVpcmUoJy4uL2lzL251bGwnKVxuXG4vKiBwcmV0dGllci1pZ25vcmUgKi9cbi8qKlxuICogQGRlc2Mgd2hlbiBBcnJheSAtPiAnYXJyYXknXG4gKiAgICAgICB3aGVuIG51bGwgLT4gJ251bGwnXG4gKiAgICAgICBlbHNlIGB0eXBlb2YgeGBcbiAqIEBwYXJhbSAge2FueX0geFxuICogQHJldHVybiB7c3RyaW5nfSB0eXBlXG4gKi9cbm1vZHVsZS5leHBvcnRzID0geCA9PiB7XG4gIHJldHVybiBpc0FycmF5KHgpXG4gICAgPyAnYXJyYXknXG4gICAgOiBpc051bGwoeClcbiAgICAgID8gJ251bGwnXG4gICAgICA6IHR5cGVvZiB4XG59XG4iXSwibmFtZXMiOlsiY29uc3QiXSwibWFwcGluZ3MiOiJBQUFBQSxHQUFLLENBQUMsT0FBTyxHQUFHLE9BQU8sQ0FBQyxhQUFhLENBQUM7QUFDdENBLEdBQUssQ0FBQyxNQUFNLEdBQUcsT0FBTyxDQUFDLFlBQVksQ0FBQzs7Ozs7Ozs7OztBQVVwQyxNQUFNLENBQUMsT0FBTyxHQUFHLFVBQUEsQ0FBQyxDQUFBLENBQUMsQUFBRztFQUNwQixPQUFPLE9BQU8sQ0FBQyxDQUFDLENBQUM7TUFDYixPQUFPO01BQ1AsTUFBTSxDQUFDLENBQUMsQ0FBQztRQUNQLE1BQU07UUFDTixPQUFPLENBQUM7Q0FDZjsifQ==